const CustomerReviews = (reviews) => {
  const { review } = reviews.reviews;
  return (
    <div className="section__customer-reviews">
      {review.map((review) => (
        <div className="section__customer-reviews__single">
          <p className="section__customer-reviews__single__header">
            <strong><i>{review.name}</i></strong>
            <small><i>&quot;{review.mainQuote}&quot;</i></small>
          </p>
          <p className="section__customer-reviews__single__body"><i>&quot;{review.text}&quot;</i></p>
          <div className="section__customer-reviews__single__footer">
            <img data-src="../images/small-blue-stars.svg" alt="small-blue-stars" width="120" />
            <a href={review.platformLink} target="_blank">
              {
                review.platform === "google" ?
                <img data-src="../images/google-icon.svg" alt="google-review" className="section__customer-reviews__single__footer__review-icon" width="100%" height="auto" /> :
                review.platform === "reviewsio" ?
                <img data-src="../images/reviewsio-icon.svg" alt="reviewsio-icon" className="section__customer-reviews__single__footer__review-icon" width="100%" height="auto" /> :
                review.platform === "yell" ?
                <img data-src="../images/yell-icon.svg" alt="yell-icon" className="section__customer-reviews__single__footer__review-icon" width="100%" height="auto" /> :
                review.platform === "trustpilot" ?
                <img data-src="../images/trustpilot-icon.svg" alt="yell-icon" className="section__customer-reviews__single__footer__review-icon" width="100%" height="auto" /> :
                review.platform
              }
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomerReviews;
